import {ENVIRONMENT} from "modules/constants";
import store from "modules/store";
import {get} from "lodash";

const trkGuid = "00355268-49ae-423d-8bd5-c744ee7444f7";

export enum EventGUID {
	HomepageLoad = "a8b27bb1-ec5f-42a3-ab9b-1e5577d2c336",
	AccountPageLoad = "2ef76c93-5204-40a4-a81e-898ce800c1d7",
	HelpPageLoad = "2f0c8a26-66d9-4ef2-a98b-ab107a25a56c",
	GameplayStart = "b2ec464a-33ae-48e3-a05d-1dcc59f5a12a",
	GameplayAction = "77788f7e-3a2a-4cce-8f30-9af36a1592ef",
	LeaderboardPageLoad = "46ee1f70-b66a-4dcf-9ef7-8dd82bbe5ada",
	NavigationHomepage = "3003904c-0fe0-40dc-b492-eb7a7faef7de",
	NavigationLeaderboard = "322e8afe-f2fa-481d-94f3-a2016ea53503",
	SummaryPageLoad = "b32fd66d-1d8a-41f7-b719-66ee6abf7137",
	PostpickShareViaX = "a3d33afc-60fe-4238-803c-3c7ad9d836d5",
	PostpickShareViaFB = "740636a1-e7d3-47a0-a523-d7fcbe57df37",
	PostpickShareViaLink = "becd048d-098c-4293-9314-1b086f482eaf",
	PostpickShareViaNativeMobile = "fcc5417e-3cd4-4cd2-b313-2088778a2f4e",
	LeaderboardProfilePageLoad = "7784f04b-075b-4268-8836-3a14b3db94c2",
	BtnToPOTG = "bfa9af0f-892d-4fcb-9cf1-d3311f38cb09",
	BtnToBTS = "9fced3c4-b343-4c72-a1f8-1653a45c1b36",
	BtnToSpinball = "e1a364ae-8495-4a5e-8d1b-b114f61d079d",
}

export const createFanHubEvent = (evtGuid: EventGUID) => {
	try {
		const allStore = store.getState();

		const clientUserId = get(allStore, "user.currentUser.id", null);
		const url = null;
		const d1 = null;
		const d2 = null;
		const d3 = null;
		const cnvValue = null;
		const cnvCurrency = null;
		const orderId = null;

		if (ENVIRONMENT === "uat") {
			console.log("fanhubEvent", {
				evtGuid,
				clientUserId,
				code: Object.keys(EventGUID).find((key) => {
					const events = EventGUID as Record<string, string>;
					return events[key] === evtGuid;
				}),
			});
		}

		window.FanHub?.createEvent(
			evtGuid,
			trkGuid,
			url,
			d1,
			d2,
			d3,
			cnvValue,
			clientUserId ? String(clientUserId) : null,
			cnvCurrency,
			orderId
		);
	} catch (e) {
		console.error(e);
	}
};

export const createFanHubEventScriptTag = (evtGuid: EventGUID) => {
	const elementName = "script";
	const SCRIPT_ID = "fanhub-tagging";
	document.getElementById(SCRIPT_ID)?.remove();
	const allStore = store.getState();
	const src = `https://tag.fanhub.geniussports.com/js/evt.js`;
	const url = new URL(src);
	const script = document.createElement(elementName);
	const clientUserId = get(allStore, "user.currentUser.id", null);

	script.id = SCRIPT_ID;
	script.src = url.toString();
	script.async = true;
	script.setAttribute("data-trkGuid", trkGuid);
	script.setAttribute("data-evtGuid", evtGuid);

	if (clientUserId) {
		script.setAttribute("data-clientUserId", String(clientUserId));
	}

	const firstJS = document.getElementsByTagName(elementName)[0];
	firstJS.parentNode!.insertBefore(script, firstJS);

	return script;
};
